import script from "./ScrollTopButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollTopButton.vue?vue&type=script&setup=true&lang=js"

import "./ScrollTopButton.vue?vue&type=style&index=0&id=782a1f65&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-782a1f65"]])

export default __exports__